import httpClient from './httpClient';

export const LIMIT_PRODUCT_ENDPOINT = '/backoffice/limit-products';

export const getLimitProductsAPI = (params) => httpClient.get(LIMIT_PRODUCT_ENDPOINT, { params });
export const getLimitProductAPI = (id) => httpClient.get(`${LIMIT_PRODUCT_ENDPOINT}/${id}`);
export const createLimitProductAPI = (payload) => httpClient.post(LIMIT_PRODUCT_ENDPOINT, payload);
export const updateLimitProductAPI = (id, payload) => httpClient.put(`${LIMIT_PRODUCT_ENDPOINT}/${id}`, payload);
export const deleteLimitProductAPI = (id) => httpClient.delete(`${LIMIT_PRODUCT_ENDPOINT}/${id}`);
